var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./banner-slider.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-67b1017f\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./banner-slider.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/home-euroregio/components/banner-slider/banner-slider.vue
// module id = 256
// module chunks = 0